define("calendar/utils/number-helpers/index", ["exports", "calendar/utils/number-helpers/compute-sign", "calendar/utils/number-helpers/floor-to-significant-digits", "calendar/utils/number-helpers/format-number-with-suffix", "calendar/utils/number-helpers/is-in-range", "calendar/utils/number-helpers/precise-round", "calendar/utils/number-helpers/ratio-to-percent"], function (_exports, _computeSign, _floorToSignificantDigits, _formatNumberWithSuffix, _isInRange, _preciseRound, _ratioToPercent) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "computeSign", {
    enumerable: true,
    get: function () {
      return _computeSign.default;
    }
  });
  Object.defineProperty(_exports, "floorToSignificantDigits", {
    enumerable: true,
    get: function () {
      return _floorToSignificantDigits.default;
    }
  });
  Object.defineProperty(_exports, "formatNumberWithSuffix", {
    enumerable: true,
    get: function () {
      return _formatNumberWithSuffix.default;
    }
  });
  Object.defineProperty(_exports, "isInRange", {
    enumerable: true,
    get: function () {
      return _isInRange.default;
    }
  });
  Object.defineProperty(_exports, "preciseRound", {
    enumerable: true,
    get: function () {
      return _preciseRound.default;
    }
  });
  Object.defineProperty(_exports, "ratioToPercent", {
    enumerable: true,
    get: function () {
      return _ratioToPercent.default;
    }
  });
  0; //eaimeta@70e063a35619d71f0,"calendar/utils/number-helpers/compute-sign",0,"calendar/utils/number-helpers/floor-to-significant-digits",0,"calendar/utils/number-helpers/format-number-with-suffix",0,"calendar/utils/number-helpers/is-in-range",0,"calendar/utils/number-helpers/precise-round",0,"calendar/utils/number-helpers/ratio-to-percent"eaimeta@70e063a35619d71f
});